import type { BodyRequest } from '@pba/utils';
import { mediaModuleClient, mediaRoutes } from 'common/services';

type MediaUploadRequestData = { formData: FormData };

export const mediaUpload = async ({ body: { formData } }: BodyRequest<MediaUploadRequestData>) =>
  mediaModuleClient.post(mediaRoutes.index, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
